/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Portalnotify_LabelInputs */

const en_portalnotify_label = /** @type {(inputs: Portalnotify_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Notifications, ${i?.count} unread`)
};

/** @type {(inputs: Portalnotify_LabelInputs) => LocalizedString} */
const ar_portalnotify_label = en_portalnotify_label;

/** @type {(inputs: Portalnotify_LabelInputs) => LocalizedString} */
const he_portalnotify_label = en_portalnotify_label;

/** @type {(inputs: Portalnotify_LabelInputs) => LocalizedString} */
const ur_portalnotify_label = en_portalnotify_label;

/** @type {(inputs: Portalnotify_LabelInputs) => LocalizedString} */
const es_portalnotify_label = en_portalnotify_label;

/** @type {(inputs: Portalnotify_LabelInputs) => LocalizedString} */
const fr_portalnotify_label = en_portalnotify_label;

/** @type {(inputs: Portalnotify_LabelInputs) => LocalizedString} */
const de_portalnotify_label = en_portalnotify_label;

/** @type {(inputs: Portalnotify_LabelInputs) => LocalizedString} */
const pt_portalnotify_label = en_portalnotify_label;

/** @type {(inputs: Portalnotify_LabelInputs) => LocalizedString} */
const hi_portalnotify_label = en_portalnotify_label;

/** @type {(inputs: Portalnotify_LabelInputs) => LocalizedString} */
const bn_portalnotify_label = en_portalnotify_label;

/**
* | output |
* | --- |
* | "Notifications, {count} unread" |
*
* @param {Portalnotify_LabelInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const portalnotify_label = /** @type {((inputs: Portalnotify_LabelInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portalnotify_LabelInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_portalnotify_label(inputs)
	if (locale === "he") return he_portalnotify_label(inputs)
	if (locale === "ur") return ur_portalnotify_label(inputs)
	if (locale === "es") return es_portalnotify_label(inputs)
	if (locale === "fr") return fr_portalnotify_label(inputs)
	if (locale === "de") return de_portalnotify_label(inputs)
	if (locale === "pt") return pt_portalnotify_label(inputs)
	if (locale === "hi") return hi_portalnotify_label(inputs)
	if (locale === "bn") return bn_portalnotify_label(inputs)
	return en_portalnotify_label(inputs)
});